"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'conversations.date.today': '今天',
    'conversations.date.yesterday': '昨天',
    'conversations.date.daysAgo': '{days} 天前',
};
